/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { DescriptionRunEventDTO } from "./DescriptionRunEventDTO";
import {
  DescriptionRunEventDTOFromJSON,
  DescriptionRunEventDTOFromJSONTyped,
  DescriptionRunEventDTOToJSON
} from "./DescriptionRunEventDTO";

/**
 *
 * @export
 * @interface PaginatedDescriptionRunEventsDTO
 */
export interface PaginatedDescriptionRunEventsDTO {
  /**
   *
   * @type {Array<DescriptionRunEventDTO>}
   * @memberof PaginatedDescriptionRunEventsDTO
   */
  items: Array<DescriptionRunEventDTO>;
  /**
   * Total rows for this run (authoritative for pagination).
   * @type {number}
   * @memberof PaginatedDescriptionRunEventsDTO
   */
  total: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedDescriptionRunEventsDTO
   */
  limit: number;
  /**
   *
   * @type {number}
   * @memberof PaginatedDescriptionRunEventsDTO
   */
  offset: number;
}

/**
 * Check if a given object implements the PaginatedDescriptionRunEventsDTO interface.
 */
export function instanceOfPaginatedDescriptionRunEventsDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "items" in value;
  isInstance = isInstance && "total" in value;
  isInstance = isInstance && "limit" in value;
  isInstance = isInstance && "offset" in value;

  return isInstance;
}

export function PaginatedDescriptionRunEventsDTOFromJSON(json: any): PaginatedDescriptionRunEventsDTO {
  return PaginatedDescriptionRunEventsDTOFromJSONTyped(json, false);
}

export function PaginatedDescriptionRunEventsDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedDescriptionRunEventsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    items: (json["items"] as Array<any>).map(DescriptionRunEventDTOFromJSON),
    total: json["total"],
    limit: json["limit"],
    offset: json["offset"]
  };
}

export function PaginatedDescriptionRunEventsDTOToJSON(value?: PaginatedDescriptionRunEventsDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    items: (value.items as Array<any>).map(DescriptionRunEventDTOToJSON),
    total: value.total,
    limit: value.limit,
    offset: value.offset
  };
}
